import {
  IAvailableApplication,
  IDeployApplicationPayload,
  ICreateWorkloadPatternPayload,
  ICreateWorkloadPatternResponse,
  IEnvironment,
  IEnvironmentPayload,
  IWorkloadPattern,
} from '../../models/AppsAndSolutionsModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { IMultipartFormData } from '../MultipartFormData.data';
import { ServerType, ServiceType } from '../ServiceType.data';

export class AppsAndSolutionsService {
  private readonly service: ApiServiceBase = new ApiService(ServiceType.None, ServerType.tangra);

  private readonly dcaService: ApiServiceBase = new ApiService(
    ServiceType.BuildDeploy,
    ServerType.dca,
  );

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  public getEnvironments({
    account,
    project,
  }: IEnvironmentPayload): Promise<Array<IEnvironment>> | Array<IEnvironment> {
    const route: string[] = [API_ROUTE.MODERNIZATION.BASE, API_ROUTE.MODERNIZATION.ENVIRONMENTS];
    return this.dcaBackendService.get({ route: route, query: { account, project } });
  }
  public getWorkloadPattern({
    account,
    project,
  }: IEnvironmentPayload): Promise<Array<IWorkloadPattern>> | Array<IWorkloadPattern> {
    const route: string[] = [
      API_ROUTE.MODERNIZATION.BASE,
      API_ROUTE.MODERNIZATION.WORKLOAD_PATTERNS,
    ];
    return this.dcaBackendService.get({ route: route, query: { account, project } });
  }
  public getAvailableApplications({
    account,
    project,
  }: IEnvironmentPayload): Promise<Array<IAvailableApplication>> | Array<IAvailableApplication> {
    const route: string[] = [API_ROUTE.MODERNIZATION.BASE, API_ROUTE.MODERNIZATION.APPLICATIONS];
    return this.dcaBackendService.get({ route: route, query: { account, project } });
  }
  public deployApplication(data: IDeployApplicationPayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.MODERNIZATION.DEPLOY_APPLICATION_AKS];
    return this.dcaService.postMultipart({ route }, [
      { name: 'userdata', content: JSON.stringify(data.userdata) },
    ]);
  }
  public createWorkloadPattern(
    uploadData: ICreateWorkloadPatternPayload,
  ): Promise<ICreateWorkloadPatternResponse> | ICreateWorkloadPatternResponse {
    return this.dcaService.postMultipart(
      {
        route: [API_ROUTE.MODERNIZATION.CREATE_WROKLOAD_PATTERN],
      },
      [{ name: 'userdata', content: JSON.stringify(uploadData.userdata) }, uploadData.file],
    );
  }
}

const appsAndSolutionsService = new AppsAndSolutionsService();
export default appsAndSolutionsService;
